import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from "@angular/core";
import {Constant} from "../../../common/constant";
import {DataService} from "../../../common/service/data.service";
import {FormBuilder, FormControl, NgForm, Validators} from "@angular/forms";
import { ShortcutService } from "../../../common/service/shortcut.service";
import { UserProfile } from "src/app/common/models/users.model";
import { AppQueries, Dispatcher, GetInfoUser, OpenOTP, SetDataOTP } from "src/app/state";
import { Subscription } from "rxjs";
import { EventManagerService } from "src/app/common/service/event-manager.service";


@Component({
  selector:"change-phone",
  templateUrl : "./change-phone.html",
  styleUrls: [
    './change-phone.scss'
  ],
})

export class ChangePhone implements OnInit,AfterViewInit, OnDestroy{
  public editForm = this.fb.group({
    isZalo: [false],
    phonePostalOld: [null],
    currentPhone: new FormControl({value: '', disabled: true}, Validators.required),
    postalPhone: [84, [Validators.required]],
    newPhone: ['', [Validators.required, Validators.pattern('[0-9]+')]],
  });
  public Constant = Constant;
  currentProfile:any = {};
  isValidated: any;
  errors: any = {};
  isSaved = false;
  user: UserProfile = new UserProfile();
  subscriptions?: Subscription[] = [];
  step: any = 1;
  dataOTP: any;
  phonePostals: any[] =[];
  constructor(
    private fb: FormBuilder,
    public eventManager: EventManagerService,
    public dataService:DataService,
    private appQueries: AppQueries,
  ) {

  }

  ngOnInit() {
    this.subscriptions.push(
      this.appQueries.userProfile$
      .subscribe((userProfile) => {
        this.user = userProfile;
        this.editForm.patchValue({
          phonePostalOld:  this.user.phonePostal || 84,
          currentPhone:  this.user.phone,
          isZalo: this.user.isZaloOtp
        });
      }),
      this.editForm.get('newPhone').valueChanges.subscribe(
        val => {
          const value = val + '';
          if (value[0] === '0') {
            this.editForm.patchValue({
              newPhone: value.substring(1)
            });
          }
          if (!this.editForm.value.isZalo && value.length && value.length < 9) {
            this.errors.lengthPhone = true;
          } else {
            this.errors.lengthPhone = false;
          }
          if (this.editForm.value.isZalo && value.length && value.length < 6) {
            this.errors.lengthPhone = true;
          } else {
            this.errors.lengthPhone = false;
          }
        }
      )
    );
    this.phonePostals = [{countryCode: 'VN', callingCode: 84}]; //this.dataService.getFull().phonePostalCodes || [];
    this.findPhonePostal();
    this.dataService.subData()
    .then((res: any) => {  
      this.phonePostals = [{countryCode: 'VN', callingCode: 84}]; //res.phonePostalCodes || [];
      this.findPhonePostal();
    })
  }
  findPhonePostal() {
    this.phonePostals = this.phonePostals.map((item) => {
      item.name = item.countryCode + ' (+' + item.callingCode + ')';
      return item;
    });
    const phonePostal = this.phonePostals.find(item => item.callingCode == this.user.phonePostal) || {};
    this.editForm.patchValue({
      phonePostalOld: phonePostal.countryCode + ' (+' + phonePostal.callingCode + ')'
    });
  }
  ngAfterViewInit() {
    ShortcutService.addOneKey(13, this.save.bind(this));
  }
  ngOnDestroy() {
    this.eventManager.destroys(this.subscriptions);
  }
  changePhonePostal(callingCode) {
    this.editForm.patchValue({
      postalPhone: callingCode
    })
  }
  disabledButton() {
    const currentPhone = this.editForm.get('currentPhone').value + '';
    if (currentPhone && currentPhone !== this.user.phone) {
      this.errors.currentPhone = true;
    } else {
      this.errors.currentPhone = false;
    }
    const keys = Object.keys(this.errors);
    const key = keys.find(key => this.errors[key]);
    return key ? true : false;
  }

  save() {
    this.isSaved = true;
    const result = this.disabledButton();
    if (result || this.editForm.invalid) {
      return;
    }
    let requestBody = {
      phonePostal: this.editForm.value.isZalo ? this.editForm.value.postalPhone || 84 : 84,
      isZaloOtp: this.editForm.value.isZalo,
      phone: this.editForm.get('newPhone').value + '',
    }
  }
  openOTP(data?) {
    let note = 'OTP sẽ gửi tới số điện thoại cũ của quý khách';
    const phone = this.editForm.get('currentPhone').value;
    this.eventManager.broadcast({
      name: 'open-otp',
      content: {
        data,
        phone,
        note,
      }
    })
  }
  hasPendingProfile() {
    return this.user.pendingProfileCounter && this.user.pendingProfileCounter['PHONE'] > 0;
  }
}
